import React from 'react';

export const TestLanguage = (data, field) => {
   const lang = localStorage.getItem("lang") || "en";
  return lang === "ar" ? data?.[field] : data?.[`${field}_en`];
  
};